import React from 'react'
import './galleryhero.less'

export default ()=>{
    return(
        <section className="gallery-hero">
            <h1>
                Events
            </h1>
        </section>
    )
}